// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"36cbca86","307":"dc53f240","397":"dc53f240"}[chunkId] + ".chunk.css";
};